<template>
    <div>
        <v-list v-if="notifications.length > 0">
            <v-list-item class="notification"
                         v-for="(notification,index) in notifications"
                         :key="notification.id"
                         :class="{'notification-selected':notification.checked === true}"
                         @click.prevent="selectNotification(index)">
                <v-list-item-avatar class="notification-icon">
                    <i class="fas fa-file-alt" style="color: #ffffff"></i>
                </v-list-item-avatar>
                <v-list-item-content>
                    <div class="content-notification">
                        <div>
                            <div class="notification-subtitle">Irregularidade {{notification.id}}</div>
                            <div class="notification-name">{{notification.date_time | timeStampToHuman}}</div>
                        </div>
                        <div>
                            <div class="notification-subtitle">Endereço</div>
                            <div class="notification-name">{{notification.address}}</div>
                        </div>
                    </div>
                    <div class="content-notification mt-3">
                        <div class="ml-auto">
                            <div class="notification-subtitle">Valor</div>
                            <div
                                class="notification-name"
                            >
                                R$ {{notification.price | integerToMoney | integerToMoney2}}
                            </div>
                        </div>
                        <div>
                            <div class="notification-subtitle">Veículo</div>
                            <div class="notification-name">{{notification.plate}}</div>
                        </div>
                    </div>
                </v-list-item-content>
                <v-list-item-action class="icon">
                    <i v-if="notification.checked === true" class="fas fa-check" style="color: #000"></i>
                </v-list-item-action>
            </v-list-item>
        </v-list>
        <div v-else class="text-center">
            Nenhuma irregularidade encontrada para este veículo.
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import axios from 'axios';

    export default {
        name: "SelectNotification",
        props:[
          'notificationsPlate'
        ],
        data:function () {
            return{
                notifications:[],
                price:0
            }
        },
        mounted(){
            axios.get('/api/inventory/product',{params:{type:4}}).then(res => {
                this.price = res.data.data[0].price;
            });
        },
        methods:{
            selectNotification:function (index) {
                this.notifications.forEach( notification => {
                   Vue.set(notification,'checked',false);
                });
                Vue.set(this.notifications[index],'checked',true);
                this.$emit('update:notification',this.notifications[index]);
            },
        },
        watch:{
            notificationsPlate:{
                deep:false,
                immediate:true,
                handler:function () {
                    if(this.notificationsPlate !== undefined && this.notificationsPlate.length > 0){
                        this.notifications = this.notificationsPlate;
                        this.selectNotification(0);
                    }else{
                        this.notifications = [];
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .notification{
        border: 2px solid transparent;
    }

    .notification-name{
        font-size: 16px;
        font-family: Roboto-Black;
        color: #9b9b9b;
    }

    .notification-icon{
        background: #9b9b9b;
    }

    .notification-subtitle{
        font-size: 12px;
        font-family: Roboto-Regular;
        color: #595959;
    }

    .notification-selected{
        background: #f8f8f8;

    }

    .notification-selected .notification-name, .notification-selected .notification-subtitle{
        color: #000;
    }

    .notification-selected .notification-icon{
        background: #000;
    }

    .content-notification{
        display: flex;
        justify-content: center;
    }

    .content-notification > div{
        flex: 1;

    }

    @media only screen and (max-width: 500px) {
        .notification-icon{
            display: none;
        }
        .content-notification{
            display: block;
            text-align: center;
            margin: 0;
            padding: 0;

        }

        .notification-name{
            font-size: 16px;
        }
        .icon{
            display: none;
        }

        .notification{
            margin: 0;
            padding: 0;
        }
        .notification-subtitle{
            width: 100%;
            margin: 0;
        }

        .content-notification > div{
            margin: 10px 0;
        }
    }
</style>
